<template>
  <b-card class="mb-0 responsive-card">
    <b-form-row>
      <h5 class="col-12 text-primary font-weight-bold pb-2">My Notifications</h5>
    </b-form-row>
    <div>
    <b-dropdown :text="tabs[notificationTab].title" v-if="isMobile">
      <b-dropdown-item v-for="({ title, disabled }, index) in tabs" @click="notificationTab = index" :disabled="disabled">
        {{ title }}
      </b-dropdown-item>
    </b-dropdown>
    <b-tabs v-model="notificationTab" pills card active-nav-item-class="active-tab-nav">
      <b-tab title="Draft" :title-link-class="'tab-nav'" :title-item-class="isMobile ? 'd-none' : ''">
        <MyDraftNotifications v-if="activeTabs.draft"/>
      </b-tab>
      <b-tab title="Pending" :title-link-class="'tab-nav'" :title-item-class="isMobile ? 'd-none' : ''" active>
        <MyPendingNotifications v-if="activeTabs.pending"/>
      </b-tab>
      <b-tab title="Active" :title-link-class="'tab-nav'" :title-item-class="isMobile ? 'd-none' : ''">
        <MyActiveNotifications v-if="activeTabs.active"/>
      </b-tab>
      <b-tab title="Closed" :title-link-class="'tab-nav'" :title-item-class="isMobile ? 'd-none' : ''">
        <MyClosedNotifications v-if="activeTabs.closed"/>
      </b-tab>
      <b-tab title="Scheduled" :title-link-class="'tab-nav'" :title-item-class="isMobile ? 'd-none' : ''">
        <MyScheduledNotifications v-if="activeTabs.scheduled"/>
      </b-tab>
    </b-tabs>
  </div>
  </b-card>
</template>
<script>
import { mapState } from 'vuex';
import MyDraftNotifications from '@/components/dashboard/MyDraftNotifications.vue';
import MyPendingNotifications from '@/components/dashboard/MyPendingNotifications.vue';
import MyActiveNotifications from '@/components/dashboard/MyActiveNotifications.vue';
import MyClosedNotifications from '@/components/dashboard/MyClosedNotifications.vue';
import MyScheduledNotifications from '@/components/dashboard/MyScheduledNotifications.vue';

export default {
  name: 'MyNotifications',
  components: {
    MyDraftNotifications,
    MyPendingNotifications,
    MyActiveNotifications,
    MyClosedNotifications,
    MyScheduledNotifications,
  },
  computed: {
    ...mapState(['isExtraSmall']),
  },
  data() {
    return {
      notificationTab: 0,
      activeTabs: {
        draft: false,
        pending: true, // Default tab is already active
        active: false,
        closed: false,
        scheduled: false,
      },
      tabs: [{
        title: 'Draft',
      },
      {
        title: 'Pending',
      },
      {
        title: 'Active',
      },
      {
        title: 'Closed',
      },
      {
        title: 'Scheduled',
      }],
      isMobile: false,
    };
  },
  watch: {
    isExtraSmall() {
      if (this.isExtraSmall) {
        this.shiftMobile();
      } else {
        this.isMobile = false;
      }
    },
    notificationTab(newTab) {
      const tabNames = [
        'draft', 
        'pending', 
        'active', 
        'closed', 
        'scheduled'
      ];
      const tabName = tabNames[newTab];      
      if (!this.activeTabs[tabName]) {
        this.activeTabs[tabName] = true;
        // Add logic to load data for the tab if needed
      }
    },
  },
  methods: {
    shiftMobile() {
      this.isMobile = true;
    },
  },
  created() {
    if (this.isExtraSmall) {
      this.shiftMobile();
    }
  },
};
</script>
<style>
.active-tab-nav {
  border-radius: 1.25rem !important;
  color: #ffffff;
}
.tab-nav {
  color: #01893f;
}
</style>
